import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const GoogleTagManager = () => {
    useEffect(() => {
        // Initialize GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }, []);

    return (
        <>
            <Helmet>
                {/* GTM Script */}
                <script>
                    {`
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-MJHRC2JL');
                    `}
                </script>
            </Helmet>
            {/* GTM noscript */}
            <noscript>
                <iframe 
                    src="https://www.googletagmanager.com/ns.html?id=GTM-MJHRC2JL"
                    height="0" 
                    width="0" 
                    style={{ display: 'none', visibility: 'hidden' }}
                    title="Google Tag Manager"
                />
            </noscript>
        </>
    );
};

export default GoogleTagManager; 